/**
 * Top-of-page advisory banner. Per ADR-0002 / Kaiyang Lesson §25.10:
 * every regpulse-core surface that exposes evaluator output MUST tell
 * the user, in their own words, that the output is not a regulatory
 * verdict.
 */
export function DisclaimerBanner() {
  return (
    <div className="app-disclaimer" role="note">
      <strong>Advisory only.</strong>
      Outputs of the evaluator and any LLM step are not regulatory verdicts.
      Human review is required before any approval, release, or filing decision.
    </div>
  );
}
